import React from "react";
import * as FaIcons from "react-icons/fa";

import relationshipList from "../../../data/relationshipList";

const R16EmergencyContacts = ({
  formData,
  onFormDataChange,
  validationCheck,
}) => {
  const {
    emergencyContact1FirstName,
    emergencyContact1LastName,
    emergencyContact1Phone,
    emergencyContact1Relationship,
    authorizedForPickup1,
    emergencyContact2FirstName,
    emergencyContact2LastName,
    emergencyContact2Phone,
    emergencyContact2Relationship,
    authorizedForPickup2,
  } = formData;

  const validatePhone = (number) => {
    const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    return re.test(String(number).toLowerCase());
  };
  return (
    <>
      {/* Emergency Contacts */}
      <div className="sub-form">
        <h3>Emergency Contacts</h3>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Emergency Contact 1 First Name </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="emergencyContact1FirstName"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={emergencyContact1FirstName}
            style={{
              border:
                validationCheck && !(emergencyContact1FirstName !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Emergency Contact 1 Last Name </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="emergencyContact1LastName"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={emergencyContact1LastName}
            style={{
              border:
                validationCheck && !(emergencyContact1LastName !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Emergency Contact 1 Phone </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="emergencyContact1Phone"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            placeholder="XXX-XXX-XXXX"
            value={emergencyContact1Phone}
            style={{
              border:
                validationCheck &&
                (emergencyContact1Phone === "" ||
                  !validatePhone(emergencyContact1Phone))
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
          {validationCheck && !validatePhone(emergencyContact1Phone) && (
            <p className="validEmail">
              Please provide a valid phone number in the following format
              XXX-XXX-XXXX
            </p>
          )}
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Emergency Contact 1 Relationship </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="emergencyContact1Relationship"
            value={emergencyContact1Relationship}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(emergencyContact1Relationship !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <option value="">Please Select </option>
            {relationshipList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Authorized for Pickup </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(authorizedForPickup1["yes"] || authorizedForPickup1["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={authorizedForPickup1["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="authorizedForPickup1"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={authorizedForPickup1["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="authorizedForPickup1"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Emergency Contact 2 First Name </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="emergencyContact2FirstName"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={emergencyContact2FirstName}
            style={{
              border:
                validationCheck && !(emergencyContact2FirstName !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Emergency Contact 2 Last Name </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="emergencyContact2LastName"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={emergencyContact2LastName}
            style={{
              border:
                validationCheck && !(emergencyContact2LastName !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Emergency Contact 2 Phone </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="emergencyContact2Phone"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            placeholder="XXX-XXX-XXXX"
            value={emergencyContact2Phone}
            style={{
              border:
                validationCheck &&
                (emergencyContact2Phone === "" ||
                  !validatePhone(emergencyContact2Phone))
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
          {validationCheck && !validatePhone(emergencyContact2Phone) && (
            <p className="validEmail">
              Please provide a valid phone number in the following format
              XXX-XXX-XXXX
            </p>
          )}
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Emergency Contact 2 Relationship </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="emergencyContact2Relationship"
            value={emergencyContact2Relationship}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(emergencyContact2Relationship !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <option value="">Please Select </option>
            {relationshipList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Authorized for Pickup</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(authorizedForPickup2["yes"] || authorizedForPickup2["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={authorizedForPickup2["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="authorizedForPickup2"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={authorizedForPickup2["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="authorizedForPickup2"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default R16EmergencyContacts;
